import { ThinkingOrb, type OrbState } from "thinking-orbs";
import "./activity.css";

export type QuiddityActivitySize = "inline" | "presence";

export type QuiddityActivityProps = {
  state: OrbState;
  size: QuiddityActivitySize;
  label: string;
  active: boolean;
  announce?: boolean;
  className?: string;
};

const PIXELS: Record<QuiddityActivitySize, 20 | 64> = {
  inline: 20,
  presence: 64,
};

export function QuiddityActivity({
  state,
  size,
  label,
  active,
  announce = true,
  className = "",
}: QuiddityActivityProps) {
  const normalizedLabel = label.trim();
  if (!normalizedLabel) throw new Error("QuiddityActivity requires a non-empty label");

  return (
    <span
      className={`quiddity-activity quiddity-activity--${size} ${className}`.trim()}
      role={announce ? "status" : undefined}
      aria-live={announce ? "polite" : undefined}
      data-activity-state={state}
      data-activity-active={active ? "true" : "false"}
      data-testid="quiddity-activity"
    >
      <ThinkingOrb
        state={state}
        size={PIXELS[size]}
        paused={!active}
        theme="auto"
        aria-hidden="true"
        data-testid="quiddity-activity-orb"
      />
      <span className="quiddity-activity__label">{normalizedLabel}</span>
    </span>
  );
}
